import { render, staticRenderFns } from "./NextSteps.vue?vue&type=template&id=99464e5a&scoped=true&"
import script from "./NextSteps.vue?vue&type=script&lang=js&"
export * from "./NextSteps.vue?vue&type=script&lang=js&"
import style0 from "./NextSteps.vue?vue&type=style&index=0&id=99464e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99464e5a",
  null
  
)

export default component.exports